//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the ProcessTemplatesAfterBuild executable.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
(function () {
    "use strict";

    angular.module("app").factory("assistanceInRequest", AssistanceInRequestFactory);

    AssistanceInRequestFactory.$inject = ["apiClientFactory"];
    function AssistanceInRequestFactory(apiClientFactory) {

        const routePrefix = "api/assistance-in/requests/";

        return {
            CopyLinkedResults: apiClientFactory.post(routePrefix + "duplicate-linked-results/"),
            Delete: apiClientFactory.delete(routePrefix),
            Get: apiClientFactory.get(routePrefix),
            GetResultsWithoutReport: apiClientFactory.post(routePrefix + "accepted/"),
            GetResultsWithReport: apiClientFactory.post(routePrefix + "reported/"),
            Save: apiClientFactory.put(routePrefix),
            SearchRequests: apiClientFactory.post(routePrefix),
            SendResults: apiClientFactory.patch(routePrefix + "completed/"),
        };
    }
})();
